import { MeterStatus } from './constants';
import isEmpty from 'lodash/isEmpty';
import { IMeterStatusType } from './IPlan.types';

export const isBusinessHour = () => {
  // Define work range
  const workHoursStart = 9;
  const workHoursEnd = 17;

  const date = new Date();
  const day = date.getDay();
  const hour = date.getHours();

  // check if its sunday or saturday and business hour
  if (day !== 0 && day !== 6 && hour >= workHoursStart && hour <= workHoursEnd) {
    return true;
  }

  return false;
};

export function isNMIHardStop(nmiStatus: IMeterStatusType | null | undefined) {
  return (
    isEmpty(nmiStatus) ||
    nmiStatus === MeterStatus.NOT_FOUND ||
    nmiStatus === MeterStatus.NOT_SERVICEABLE
  );
}

export function isNMIServiceable(nmiStatus: IMeterStatusType | null | undefined) {
  return isEmpty(nmiStatus) ? false : nmiStatus !== MeterStatus.NOT_SERVICEABLE;
}

export function isMirnNotFound(mirnStatus: IMeterStatusType | null | undefined) {
  return isEmpty(mirnStatus) || mirnStatus === MeterStatus.NOT_FOUND;
}

export function isNMIBelowThreshold(nmiStatus: IMeterStatusType) {
  return nmiStatus === MeterStatus.BELOW_THRESHOLD;
}
